module.exports = __webpack_public_path__ + "img/jenks-pro.4b01500e.jpg";